<template>
  <div class="">
    <meta charset="utf-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0">
    <meta name="author" content="Kaio Nascimento">
    <meta name="generator" content="VueJS - Kaio Nascimento">
    <link rel="shortcut icon" type="image/png" href="../../assets/images/ibcgp/favicon.png"/>
  </div>  
</template>

<script async src="https://www.googletagmanager.com/gtag/js?id=G-Y60JFQ6DV5"></script>

<script>
  import '../../assets/css/bootstrap.min.css';
  import '../../assets/css/themify-icons.css';
  import '../../assets/css/slick-theme.css';
  import '../../assets/css/slick.css';
  import '../../assets/css/fancybox.min.css';
  import '../../assets/css/aos.css';
  import '../../assets/css/style.css';
  import '../../assets/css/ibcgp-modern.css';

  export default {
    created(){
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'G-Y60JFQ6DV5');
    }
  }
</script>

<style scoped>
  
</style>